<template>
  <component
    :is="link ? 'UILinkComponent' : 'button'"
    v-if="label"
    v-bind="link ? { to: link, target: resolvedTarget } : { type: 'button' }"
    :aria-label="`button: ${label}`"
    class="icon-btn"
    :class="[props.style && `style-${props.style}`]"
    @click="!link ? emit('click') : undefined"
  >
    <UIIconComponent
      class="icon default"
      :icon="props.customIcon ?? 'chevron-right'"
      aria-hidden="true"
    />
  </component>
</template>

<script setup lang="ts">
  const props = defineProps<{
    link?: string
    label: string
    target?: string
    style?: 'link'
    customIcon?: string
  }>()

  const emit = defineEmits<{
    click: []
  }>()

  // Check if the link is a view.asp link (for download links), which should open in a new tab otherwise it doesn't work properly
  const isViewAspLink = /view\.asp\?guid=[0-9a-f-]{36}/i.test(props.link ?? '')
  const resolvedTarget = computed(() => (isViewAspLink ? '_blank' : props.target))
</script>
